var _rect, _path, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyMetricsBlockEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 64,
    rx: 7.5,
    fill: "#F0F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 15.5999C54.2278 15.5999 56.3644 16.4849 57.9397 18.0602C59.515 19.6355 60.4 21.7721 60.4 23.9999C60.4 26.2277 59.515 28.3643 57.9397 29.9396C56.3644 31.5149 54.2278 32.3999 52 32.3999C49.7722 32.3999 47.6356 31.5149 46.0603 29.9396C44.485 28.3643 43.6 26.2277 43.6 23.9999C43.6 21.7721 44.485 19.6355 46.0603 18.0602C47.6356 16.4849 49.7722 15.5999 52 15.5999ZM52 33.5999C54.5461 33.5999 56.9879 32.5885 58.7882 30.7881C60.5886 28.9878 61.6 26.546 61.6 23.9999C61.6 21.4538 60.5886 19.012 58.7882 17.2117C56.9879 15.4113 54.5461 14.3999 52 14.3999C49.4539 14.3999 47.0121 15.4113 45.2118 17.2117C43.4114 19.012 42.4 21.4538 42.4 23.9999C42.4 26.546 43.4114 28.9878 45.2118 30.7881C47.0121 32.5885 49.4539 33.5999 52 33.5999ZM52.6 20.3999H51.4V20.9999V23.3999H49H48.4V24.5999H49H51.4V26.9999V27.5999H52.6V26.9999V24.5999H55H55.6V23.3999H55H52.6V20.9999V20.3999Z",
    fill: "#465DD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#465DD8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 63,
    rx: 7.5,
    stroke: "#465DD8",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMetricsBlockEdit);
export default __webpack_public_path__ + "static/media/EmptyMetricsBlockEdit.737348dc.svg";
export { ForwardRef as ReactComponent };